import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4911c61e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banners-container" }
const _hoisted_2 = { class: "page-default page-media" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-new" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_6 = {
  class: "albums",
  style: {"height":"350px","overflow":"hidden"}
}
const _hoisted_7 = { class: "album-item" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "page-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-hot" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_14 = {
  class: "albums",
  style: {"height":"290px","overflow":"hidden"}
}
const _hoisted_15 = { class: "page-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-all" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_18 = ["onMouseover"]
const _hoisted_19 = {
  key: 0,
  class: "albums",
  style: {"height":"590px","overflow":"hidden"}
}
const _hoisted_20 = { class: "page-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_22 = {
  class: "authors",
  style: {"height":"150px","overflow":"hidden"}
}
const _hoisted_23 = { class: "name line1" }
const _hoisted_24 = { class: "down" }
const _hoisted_25 = { class: "page-default page-media" }

import movieHome, { State } from '@/store/movies/home';
import Avatar from '@/views/components/Avatar.vue';
import * as filters from '@/views/filters';
import * as links from '@/views/links';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import Album from '../albums/Album.vue';
import Banner from './Banner.vue';
import Download from './Download.vue';
import News from './News.vue';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[movieHome.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].movieText)

const state = reactive({
    recommendsIndex: 0,
    updatesIndex: 1,
    categorysIndex: 0,
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Banner)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(News),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          class: _normalizeClass(["btn round", _unref(state).updatesIndex == 1 ? 'red' : 'gray']),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).updatesIndex = 1))
        }, _toDisplayString(_unref(lang).new_add), 35),
        _createElementVNode("a", {
          class: _normalizeClass(["btn round", _unref(state).updatesIndex == 0 ? 'red' : 'gray']),
          onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).updatesIndex = 0))
        }, _toDisplayString(_unref(lang).new_update), 35),
        _createVNode(_component_router_link, {
          class: "right go link c-thirdary",
          to: _unref(links).all(_unref(state).updatesIndex == 1 ? 'addtimeOrder' : 'edittimeOrder')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(lang).more), 1),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).updates[_unref(state).updatesIndex], (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                (_unref(state).updatesIndex == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(filters).date2(item.edittime)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(filters).date2(item.addtime)), 1))
              ])
            ]),
            _createVNode(Album, { album: item }, null, 8, ["album"])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("a", {
          class: _normalizeClass(["btn round", _unref(state).recommendsIndex == 0 ? 'red' : 'gray']),
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).recommendsIndex = 0))
        }, _toDisplayString(_unref(lang).hot_recommend), 35),
        _createElementVNode("a", {
          class: _normalizeClass(["btn round", _unref(state).recommendsIndex == 1 ? 'red' : 'gray']),
          onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).recommendsIndex = 1))
        }, _toDisplayString(_unref(lang).hot_rank), 35),
        _createVNode(_component_router_link, {
          class: "right go link c-thirdary",
          to: _unref(links).all(_unref(state).recommendsIndex == 0 ? 'recommend' : 'hitsOrder')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(lang).more), 1),
            _hoisted_13
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).recommends[_unref(state).recommendsIndex], (item) => {
          return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_unref(data).categorys[_unref(state).categorysIndex])
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "right go link c-thirdary",
              to: _unref(links).all('addtimeOrder', _unref(data).categorys[_unref(state).categorysIndex].id)
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(lang).more), 1),
                _hoisted_17
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).categorys, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["btn round", i == _unref(state).categorysIndex ? 'red' : 'gray']),
            onMouseover: ($event: any) => (_unref(state).categorysIndex = i)
          }, _toDisplayString(item.name), 43, _hoisted_18))
        }), 256))
      ]),
      (_unref(data).categorys[_unref(state).categorysIndex])
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).categorys[_unref(state).categorysIndex].list, (item) => {
              return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("b", null, _toDisplayString(_unref(lang).author), 1),
        _createVNode(_component_router_link, {
          class: "right go link c-thirdary",
          to: _unref(links).author()
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(lang).more), 1),
            _hoisted_21
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).speakers, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: "link line",
            to: _unref(links).author(item.id)
          }, {
            default: _withCtx(() => [
              _createVNode(Avatar, {
                url: item.thumb
              }, null, 8, ["url"]),
              _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(Download)
      ])
    ])
  ]))
}
}

})